import PropTypes from 'prop-types';
import React, { useReducer } from 'react';
import { initialState, reducer } from './Reducer';

export const DataContext = React.createContext({
  state: initialState,
  dispatch: () => null,
});

export const DataProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <DataContext.Provider value={[state, dispatch]}>{children}</DataContext.Provider>;
};

// proptypes
DataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
